import { initialState, JobOfferApplicationState } from './jobOfferApplication.state';
import { JobOfferApplicationAction, JobOfferApplicationActionTypes } from './jobOfferApplication.actions';
import { QuestionnaireAnswer } from '../jobOffers/jobOffers.dto';
import { SubmitJobApplicationCommandResponse } from './jobOfferApplication.thunk';

export default (
    state: JobOfferApplicationState = initialState,
    action: JobOfferApplicationAction
): JobOfferApplicationState => {
    switch (action.type) {
        case JobOfferApplicationActionTypes.SAVE_STATIC_QUESTIONS_ANSWERS:
            return {
                ...state,
                error: null,
                answers: {
                    ...state.answers,
                    firstName: action.firstName,
                    lastName: action.lastName,
                    prefix: action.prefix,
                    phoneNumber: action.phoneNumber,
                    email: action.email
                }
            };

        case JobOfferApplicationActionTypes.SAVE_ADDITIONAL_ANSWERS:
            // add new answers
            // but also replace existing answer items with the new ones
            const newAdditionalQuestionnaireAnswers = [...state.answers.additionalQuestionnaireAnswers];

            action.additionalAnswers.forEach((newAnswer: QuestionnaireAnswer) => {
                const oldAnswerIndex = newAdditionalQuestionnaireAnswers.findIndex(
                    oldAnswer => oldAnswer.questionId === newAnswer.questionId
                );

                if (oldAnswerIndex > -1) {
                    newAdditionalQuestionnaireAnswers.splice(oldAnswerIndex, 1, newAnswer);
                } else {
                    newAdditionalQuestionnaireAnswers.push(newAnswer);
                }
            });

            return {
                ...state,
                error: null,
                answers: {
                    ...state.answers,
                    additionalQuestionnaireAnswers: newAdditionalQuestionnaireAnswers
                }
            };

        case JobOfferApplicationActionTypes.SUBMIT_APPLICATION_STARTED:
            return {
                ...state,
                error: null
            };

        case JobOfferApplicationActionTypes.SUBMIT_APPLICATION_FINISHED:
            return {
                ...state,
                error: null,
                formErrors: []
            };

        case JobOfferApplicationActionTypes.SUBMIT_APPLICATION_FAILED:
            if (typeof action.error === 'string') {
                return {
                    ...state,
                    error: {
                        error: action.error
                    }
                };
            } else {
                return {
                    ...state,
                    formErrors: (action.error as SubmitJobApplicationCommandResponse).errors
                };
            }

        default:
            return state;
    }
};
